export const imageUrl = (imagePath) => {
    if (!imagePath) return "";
    return "https://smartsathi.in/images/" + imagePath;
};
